/**
 * Helper para codificar y decodificar datos de sesión en URL
 * Esto permite pasar datos entre aplicaciones de Azure Static Web Apps
 */

/**
 * Codifica los datos de sesión para pasarlos por URL
 * @param {object} sessionData - Datos de sesión (dataUser, dataToken, etc.)
 * @returns {string} - String codificado para URL
 */
export const encodeSessionData = (sessionData) => {
  try {
    const jsonString = JSON.stringify(sessionData);
    return btoa(encodeURIComponent(jsonString));
  } catch (error) {
    console.error('Error encoding session data:', error);
    return null;
  }
};

/**
 * Decodifica los datos de sesión desde URL
 * @param {string} encodedData - String codificado desde URL
 * @returns {object|null} - Objeto con datos de sesión o null si hay error
 */
export const decodeSessionData = (encodedData) => {
  try {
    const jsonString = decodeURIComponent(atob(encodedData));
    return JSON.parse(jsonString);
  } catch (error) {
    console.error('Error decoding session data:', error);
    return null;
  }
};

/**
 * Obtiene los parámetros de sesión desde la URL actual
 * @returns {object|null} - Datos de sesión decodificados o null
 */
export const getSessionFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const sessionParam = urlParams.get('session');
  
  if (!sessionParam) {
    return null;
  }
  
  return decodeSessionData(sessionParam);
};

/**
 * Limpia los parámetros de sesión de la URL sin recargar
 */
export const cleanSessionFromUrl = () => {
  const url = new URL(window.location);
  url.searchParams.delete('session');
  window.history.replaceState({}, document.title, url.pathname + url.hash);
};
